import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { BusinessLinkType } from '@meniudigital/shared'
import Setting from '../Setting'
import { useBusinessLinks } from '../hooks/useBusinessLinks'
import { IS_DESKTOP_OR_TABLET } from '../..'

export default function NutritionalLinkSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const { isBusinessInfoVisible, toggleBusinessMedium, updateBusinessMediumLinkUrl, isUrlInvalid } = useBusinessLinks({
    user,
    dispatch,
  })

  if (!user) {
    return null
  }

  return (
    <Setting
      title={IS_DESKTOP_OR_TABLET ? 'Link către Valori Nutriționale' : 'Link Valori Nutriționale'}
      iconPath="/icons/leaf-circle.png"
      isEnabled={isBusinessInfoVisible(BusinessLinkType.NutritionalValuesExternal)}
      value={(user?.businessInfo || []).find(x => x.type === BusinessLinkType.NutritionalValuesExternal)?.url}
      placeholder="Linkul unde se pot găsi valorile nutriționale detaliate"
      onValueUpdate={newValue => updateBusinessMediumLinkUrl(newValue, BusinessLinkType.NutritionalValuesExternal)}
      onToggle={() => toggleBusinessMedium(BusinessLinkType.NutritionalValuesExternal)}
      hasError={isUrlInvalid(BusinessLinkType.NutritionalValuesExternal)}
      infoText="Dacă oferi informații nutriționale de pe un site extern, poți adăuga linkul aici."
    />
  )
}
